/* eslint-disable */
<template>
  <section class="members-data">
    <div class="mt-2 md:mt-3 lg:mt-1">

      <Table
        :data-source="tableFormatedData"
        :columns="columns"
        :loading="ticketsQuery?.isFetching"
        :pagination="false"
      >
        <template #bodyCell="{ column, record }">
          <template v-if="column.key === 'date'">
            <span v-if="record?.date" class="whitespace-nowrap w-full flex justify-center">{{
              record?.date
            }}</span>
            <span v-else class="w-full flex justify-center text-yellow-600">N/A</span>
          </template>
          <template v-if="column.key === 'sent'">
            <span class="whitespace-nowrap w-full flex justify-center">
              <span v-if="record?.sent" class="text-green-600 w-full flex justify-center">
                <PhCheckCircle weight="duotone" size="18" />
              </span>
              <span v-if="!record?.sent" class="text-red-600 w-full flex justify-center">
                <PhXCircle weight="duotone" size="18" />
              </span>
            </span>
          </template>
          <template v-if="column.key === 'rule'">
            <span class="whitespace-nowrap w-full flex justify-center">
              <p v-if="record?.rule == 'all'">All users</p>
              <p v-if="record?.rule == 'complete'">
                Users with complete registration (users completed the survey/registration)
              </p>
              <p v-if="record?.rule == 'incomplete'">Users with incomplete registration</p>
            </span>
          </template>
          <template v-if="column.key === 'view'">
            <span class="whitespace-nowrap w-full flex justify-center">
              <Button
                type="primary"
                size="small"
                class="rounded shadow flex items-center gap-2"
                @click="showEmail(record?.key)"
              >
                <PhFile weight="duotone" :size="16" />
              </Button>
            </span>
          </template>
        </template>
      </Table>
      <div
        v-if="customEmailsQuery && customEmailsQuery.data"
        class="mt-6 flex items-center justify-center"
      >
        <Pagination
          :current="customEmailsQuery?.data?.current_page"
          :total="customEmailsQuery?.data?.total"
          show-less-items
          @change="handlePaginationChange"
          :page-size="10"
        />
      </div>
    </div>
    <CustomSentEmailsQuery :page="page" :per_page="10" :key="page" />
  </section>
</template>
<script>
/* eslint-disable */
import {
  Table,
  InputSearch,
  Select,
  Spin,
  DatePicker,
  Pagination,
  Popconfirm,
  Button,
  Modal,
  Row,
  Col,
  message,
} from 'ant-design-vue';
import dayjs from 'dayjs';

// import handleResErrors from '@/utils/handleResErrors';
import CustumSelect from '@/components/shared/form/CustumSelect.vue';

import {
  PhCheck,
  PhCheckCircle,
  PhFile,
  PhFilePdf,
  PhProhibit,
  PhTrash,
  PhX,
  PhXCircle,
} from 'phosphor-vue';
import CustumInput from '@/components/shared/form/CustumInput.vue';
import debounce from 'lodash.debounce';
import ticketsApi from '@/services/apis/admin/tickets.api';
import { MEMBERS } from '@/store/types';
import CustomSentEmailsQuery from '@/services/queries/members/CustomSentEmailsQuery.vue';

export default {
  components: {
    Table,
    PhCheck,
    PhFilePdf,
    PhProhibit,
    Row,
    Col,
    CustumInput,
    Modal,
    PhTrash,
    PhX,
    InputSearch,
    PhFilePdf,
    PhFile,
    Select,
    Popconfirm,
    Spin,
    Button,
    DatePicker,
    CustumSelect,
    Pagination,
    CustomSentEmailsQuery,
    PhCheckCircle,
    PhXCircle,
  },
  data() {
    return {
      columns: [
        {
          title: 'Date',
          dataIndex: 'date',
          key: 'date',
        },
        {
          title: 'Send to',
          dataIndex: 'rule',
          key: 'rule',
        },
        {
          title: 'View',
          dataIndex: 'view',
          key: 'view',
        },
      ],

      tableData: [],
      statues: ['In Progress', 'Backlog', 'Resolved'],
      search: '',
      searchData: [],
      page: 1,
      pageSize: 10,
      employer_id: null,
      type: 'year',
      searchStatus: null,
      targetStatus: null,
      addCreditLoading: false,
      ticketShow: null,
      years: [],
      dateData: [
        // { id: 1, name: 'custom date' },
        { id: 'month', name: 'Monthly' },
        { id: 'year', name: 'Yearly' },
        { id: 'all', name: 'All Data' },
      ],
      statusData: [
        // { id: 1, name: 'custom date' },
        { id: 'pending', name: 'pending' },
        { id: 'approved', name: 'approved' },
        { id: 'rejected', name: 'rejected' },
      ],
      dateVal: dayjs(new Date().getFullYear() + '/12', 'YYYY/MM'),
      keyword: '',
      pdfLoading: false,
      rejectionMsg: '',
      creditModal: false,
      creditModal2: false,
      modalUserId: null,
      detailsLoading: false,
      per_page: 10,
    };
  },
  computed: {
    dates() {
      if (!this.dateVal) return [null, null];
      if (this.type === 'month') {
        const start = dayjs(this.dateVal).startOf('month').format('YYYY-MM-DD');
        const end = dayjs(this.dateVal).endOf('month').format('YYYY-MM-DD');
        return [start, end];
      }

      if (this.type === 'year') {
        const start = dayjs(this.dateVal).startOf('year').format('YYYY-MM-DD');
        const end = dayjs(this.dateVal).endOf('year').format('YYYY-MM-DD');
        return [start, end];
      }

      return [null, null];
    },
    customEmailsQuery() {
      return this.$store.state.members.customSentEmailQuery;
    },
    tableFormatedData() {
      // if (!this.ticketsQuery || !this.ticketsQuery.data) return [];

      const data =
        this?.customEmailsQuery?.data?.data?.map((d, ix) => ({
          key: d?._id || ix,
          sent: d?.sent ?? false,
          date: this.convertUtcToLocalTime(d?.when_to_send ?? '')?.formattedString,
          rule: d?.rule,
        })) ?? [];
      return data;
    },
  },
  methods: {
    showEmail(key) {
      this.$store.commit(MEMBERS.SET_MODAL_PROGRAM, key);
      this.$store.commit(MEMBERS.SET_MODAL_VIEW, true);
    },
    handleSearch(e) {
      this.debounceSearch(e.target.value, this);
    },
    handleSearchStatus(e) {
      this.searchStatus = e.target.value;
      this.page = 1;
    },
    handleChangeStatus(e) {
      this.targetStatus = e.target.value;
    },
    convertUtcToLocalTime(utcTimestamp) {
      // Parse the UTC timestamp
      const date = new Date(utcTimestamp);

      // Format options for displaying the date and time
      const dateOptions = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        timeZoneName: 'short',
      };

      // Get formatted date and time in user's local timezone
      const localDateTime = date.toLocaleString(undefined, dateOptions);

      // Get the timezone name
      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      // Get individual components
      const year = date.getFullYear();
      const month = date.getMonth() + 1; // getMonth() returns 0-11
      const day = date.getDate();
      const hours = date.getHours();
      const minutes = date.getMinutes();
      const seconds = date.getSeconds();

      // Format individual components in a structured way
      const formattedComponents = `${year}-${month.toString().padStart(2, '0')}-${day
        .toString()
        .padStart(2, '0')} ${hours.toString().padStart(2, '0')}:${minutes
        .toString()
        .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;

      return {
        original: utcTimestamp,
        formatted: localDateTime,
        timezone: timeZone,
        components: {
          year,
          month,
          day,
          hours,
          minutes,
          seconds,
        },
        formattedString: formattedComponents,
      };
    },
    async changeStatus() {
      // this.statusLoading = true;
      try {
        const id = this.ticketShow?.key;
        const status = this.targetStatus;
        const res = await ticketsApi.changeTicketStatus({ id, status });
        message.success('Status updated successfully');

        this.creditModal2 = false;
        this.targetStatus = null;
        if (this.ticketsQuery) {
          await this.ticketsQuery.refetch();
        }
      } catch (error) {
        message.error(handleResErrors(error), 10);
      } finally {
        // this.statusLoading = false;
      }
    },
    debounceSearch: debounce((search, app) => {
      // eslint-disable-next-line no-param-reassign
      app.search = search;
      // eslint-disable-next-line no-param-reassign
      app.page = 1;
    }, 400),
    handlePaginationChange(page) {
      // , filters, sorter, data
      this.page = page;
    },
    openTicket(ticketObj) {
      this.creditModal = true;
      this.ticketShow = ticketObj;
    },
    openTicket2(ticketObj) {
      this.ticketShow = ticketObj;
      this.creditModal2 = true;
    },
    openTicket3() {
      this.creditModal = false;
      this.creditModal2 = true;
    },
  },
};
</script>
